import { object, string } from "yup";

let taskCommentSchema = object({
  message: string().required("Message cannot be empty."),
});

export default taskCommentSchema;
